/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tourhelp_None_ReasonInputs */



/**
* | output |
* | --- |
* | "Tours for this page are being added." |
*
* @param {Tourhelp_None_ReasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const tourhelp_none_reason = /** @type {((inputs?: Tourhelp_None_ReasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_None_ReasonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Tours for this page are being added.")
});